module.exports = __webpack_public_path__ + "static/practice-mgmt-banner-mobile-48a808538574e91402808936234e8b85.jpg";